import axios from "axios";
import { API_BASE_URL } from "../config";
import { getAuthHeaders } from "./developerApi";

const baseUrl = `${API_BASE_URL}/payment-reports/novapay`;

export const uploadPediakidInvoice = async (file) => {
    const formData = new FormData();
    formData.append("file", file);
    const auth = getAuthHeaders();
    const response = await axios.post(`${baseUrl}/pediakid/upload`, formData, {
        ...auth,
        headers: {
            ...(auth.headers || {}),
            "Content-Type": "multipart/form-data",
        },
    });
    return response.data;
};

export const uploadPediakidInvoices = async (files) => {
    const formData = new FormData();
    Array.from(files || []).forEach((file) => {
        formData.append("files", file);
    });
    const auth = getAuthHeaders();
    const response = await axios.post(`${baseUrl}/pediakid/upload-batch`, formData, {
        ...auth,
        headers: {
            ...(auth.headers || {}),
            "Content-Type": "multipart/form-data",
        },
    });
    return response.data;
};

export const getNovaPayDrafts = async ({ draftStatus, supplierCode, limit = 100 } = {}) => {
    const params = { limit };
    if (draftStatus) params.draft_status = draftStatus;
    if (supplierCode) params.supplier_code = supplierCode;
    const response = await axios.get(`${baseUrl}/drafts`, {
        ...getAuthHeaders(),
        params,
    });
    return response.data || [];
};

export const updateNovaPayDraft = async (draftId, payload) => {
    const response = await axios.put(`${baseUrl}/drafts/${draftId}`, payload, getAuthHeaders());
    return response.data;
};

export const confirmNovaPayDraft = async (draftId, payload) => {
    const response = await axios.post(`${baseUrl}/drafts/${draftId}/confirm`, payload, getAuthHeaders());
    return response.data;
};

export const deleteNovaPayDraft = async (draftId) => {
    const response = await axios.delete(`${baseUrl}/drafts/${draftId}`, getAuthHeaders());
    return response.data;
};

export const exportNovaPayDrafts = async (draftIds) => {
    const response = await axios.post(`${baseUrl}/export`, { draft_ids: draftIds }, getAuthHeaders());
    return response.data;
};

export const novaPayExportDownloadUrl = (exportId) => `${baseUrl}/exports/${exportId}/download`;

export const downloadNovaPayExport = async (exportId) => {
    const response = await axios.get(novaPayExportDownloadUrl(exportId), {
        ...getAuthHeaders(),
        responseType: "blob",
    });
    return response;
};
